import React, { Component } from 'react';
import firebase from 'firebase';
import 'moment/locale/es';
import './style.css';
import Select from 'react-select';
import Alert from 'react-s-alert';
import Modal from 'react-modal';
import moment from 'moment';
import { Pulse } from 'react-preloading-component';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { setProgramacion } from '../../actions'
import { sendLog } from '../../util'

class CancelacionViaje extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tiposViajes: this.props.tiposViajes || [],
            filtro: { label: '', value: 'Todos' },
            rutas: this.props.rutas || [],
            programacion: [],
            programacionDia: [],
            vehiculos: [],
            showModal: false,
            showModalL: false,
            showModalFinalizar: false,
            justificacion: '',
            vehiculo: { label: 'No Asignado', value: '' },
            conductor: { label: 'No Asignado', value: '' },
            template: false,
            isLoading: false,
            isFilter: false,
            carreteras: [],
            comentario: '',
            carretera: '',
            km: 0,
            filterRutas: []
        };
        this.AlertaContenido = ({
            id,
            classNames,
            styles,
            message,
            customFields,
            handleClose,
        }) => {
            const handleConfirm = () => {
                this.liberarViaje()
                Alert.close(id);
                this.setState({
                    template: false
                })
            }
            return (
                <div className={classNames} id={id} style={styles}>
                    <div className='s-alert-box-inner'>
                        {message}
                    </div>
                    <br />
                    <br />
                    <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
                    <button className="customButton btn btn-default btn-alerts btn-m-r" onClick={this.handleClickClose}>Cancelar</button>
                    <span className='s-alert-close' onClick={handleClose}></span>
                </div>
            );
        }
    }

    getTiposViaje() {
        firebase.database().ref('TiposViajes').once('value').then(snap => {
            let tiposViajes = [];
            let o = { label: 'Todas las rutas', value: 'Todos' };
            tiposViajes.push(o);
            snap.forEach(element => {
                let obje = element.val();
                o = { label: obje.nombre, value: element.key };
                tiposViajes.push(o);
            });
            this.setState({ tiposViajes });
        })
    }

    componentWillMount = () => {
        setTimeout(() => {
            this.getTiposViaje();
        }, 1000);
    }

	liberarOldScanner = async (programacionKey)=>{
		const snapSync = await firebase.database().ref()
		.child('SyncApps')
		.orderByChild('programacionDia')
		.equalTo(programacionKey)
		.once('value');

		snapSync.forEach(element => {
			firebase.database().ref().child('SyncApps/' + element.key).remove();
		});
	}

	liberarScanner = async (programacionKey)=>{
		const snap = await firebase.database()
			.ref('ProgramacionDia')
			.child(programacionKey)
			.child('codigo')
			.once('value');

		if(snap.exists()){
			const codigo = snap.val();
	
			firebase.database().ref()
				.child('scannerCodes')
				.child(codigo)
				.update({
					disponible:true,
					programacionDia:false
				})
		}

		this.liberarOldScanner(programacionKey);
	}

    liberar = (ruta) => {
        this.setState({ ruta, template: true });

        const customerName = 'Bacer';
        Alert.success('¿ Deseas liberar este viaje ?', {
            position: 'top-right',
            timeout: 3000,
            customFields: {
                customerName: customerName
            }
        });

    }


    selectTipoViaje(filtro) { this.setState({ filtro }) }



    getFirstWord(s, separator) {
        let r = s.split(separator);
        return r[0];
    }

    getConductor(conductor, isName) {
        let res = this.props.conductores.filter(c => c.value === conductor);
        return res.length > 0 ? isName ? res[0].label : res[0].value : 'No Asignado';
    }

    getVehiculo(vehiculo, isName) {
        let res = this.props.vehiculos.filter(c => c.value === vehiculo);
        return res.length > 0 ? isName ? res[0].label : res[0].value : 'No Asignado';
    }

    getProgramacionDia = (programacion) => {
        let date = new Date();
        let mes = date.getMonth() + 1;
        mes = parseInt(mes) < 10 ? '0' + mes : mes;
        let fechaB = new Date(date.getFullYear() + '/' + mes + '/' + date.getDate());
        let dateFormat = fechaB.toDateString() + ' 00:00:00 GMT-0600 (hora estándar central)';
        firebase.database().ref('ProgramacionDia').orderByChild('fecha').equalTo(String(dateFormat)).once('value', snap => {
            let programacionDia = [];
            snap.forEach(element => {
                let datos = element.val();
                let obje = { estadoViaje: '' };
                let splitH = (datos["horaInicio"] !== undefined) ? datos.horaInicio.split(":") : ["00", "00"];
                let now = moment().hour(Number(splitH[0])).minute(Number(splitH[1])).format('HH:mm');
                obje = { ...datos, key: element.key, horaInicio: now };
                obje['estadoViaje'] = datos.estado;
                programacionDia.push(obje);
            });
            this.mergeRutas(programacionDia, programacion);
        })
    }

    mergeRutas(programacionDia, programacion, filter = null, ) {
        firebase.database().ref('Rutas').once('value').then(snap => {
            let rutas = [];
            snap.forEach(element => {
                let obje = element.val();
                obje = { ...obje, key: element.key };
                rutas.push(obje);
            });
            let res = [];
            for (let i = 0; i < programacionDia.length; i++) {
                let tr = rutas.find(r => r.key === programacionDia[i].ruta);
                res.push({ ...programacionDia[i], ...tr, key: programacionDia[i].key });
            }
            this.mergeProgramacion(res, filter, programacion);
        });
    }

    mergeProgramacion(programacionDia, filter, programacion) {
        let { setProgramacion } = this.props;
        let res = [];
        for (let i = 0; i < programacionDia.length; i++) {
            let tr = programacion.find(r => r.key === programacionDia[i].programacion);
            if (tr !== undefined) {
                programacionDia[i]['nombProgra'] = tr.vuelo;
                programacionDia[i].solicitante = tr.solicitante
            }
            res.push({ ...programacionDia[i], ...tr, key: programacionDia[i].key });
        }
        if (filter !== true) {
            setProgramacion(programacionDia)
        }
        else {
            this.setState({ programacionDia });
        }
        this.setState({ isLoading: false, isFilter: filter });
    }

    handleChange = (data) => { this.setState({ justificacion: data.target.value }) }

    showModal = (ruta) => { this.setState({ showModal: true, ruta }) }

    showModalFinalizar = (ruta) => {
        if (ruta.conductor || ruta.vehiculo) {
            firebase.database().ref('Carreteras').once('value').then(snap => {
                let data = snap.val();
                this.setState({ showModalFinalizar: true, carreteras: data, ruta });
            })
        }
        else {
            Alert.error(' Para finalizar el viaje debe tener asiganado conductor y vehiculo ', {
                position: 'top-right',
                timeout: 3000,
            });
        }
    }

    handleModalFinalizar = (evt) => {
        const element = evt.target;
        switch (evt.target.name) {
            case "comentario":
                this.setState({ comentario: element.value })
                break;
            case "carretera":
                this.setState({ carretera: element.value })
                break;
            case "km":
                this.setState({ km: element.value })
                break;
        }
    }

    async finalizarViaje() {

        const { ruta, comentario, carretera, km } = this.state;
        const { vehiculo, conductor } = ruta;
        if (!carretera)
            Alert.error(' Falta seleccionar carretera ', {
                position: 'top-right',
                timeout: 3000,
            });
        else if (!km)
            Alert.error(' Falta ingresar kilometraje ', {
                position: 'top-right',
                timeout: 3000,
			});
			
		else if(!comentario)
            Alert.error(' Falta ingresar comentario ', {
                position: 'top-right',
                timeout: 3000,
            });

        else {

            const promises = [];

            this.liberarScanner(ruta.key);

            const promiseProgra = firebase.database().ref().child('ProgramacionDia/' + ruta.key).update({
                coordenadas: "13.6672887,-89.1932757",
                comentario: `Finalizados desde web por: ${comentario}. ${moment().format('DD/MM/YYYY HH:mm')}`,
                estado: 'Finalizado',
                finalizo: firebase.database.ServerValue.TIMESTAMP,
                carretera,
                kmFinal: km
            });

            sendLog({ tipo: 'viaje_finalizado', informacion_extra: { programacionDia: ruta.key } });
            promises.push(promiseProgra);

            const promiseVehi = firebase.database().ref().child('Vehiculos/' + vehiculo).update({
                estado: 'Disponible',
                viajeAsignado: false
            });
            promises.push(promiseVehi);

            const promiseConduc = firebase.database().ref().child('Empleados/' + conductor).update({
                viajeAsignado: false
            });
            promises.push(promiseConduc);


            await Promise.all(promises);
            this.setState({
                showModalFinalizar: false,
                comentario: "",
                carretera: "",
                km: 0,
            });

            Alert.success(' Viaje finalizado ', {
                position: 'top-right',
                timeout: 3000,
            });

        }
    }

    async cancelarViaje() {
        const { ruta, justificacion } = this.state;
        const { vehiculo, conductor, key } = ruta;

        const promises = [];
        if (justificacion) {
            if (vehiculo) {
                const promise = firebase.database().ref('Vehiculos').child(vehiculo).update({ estado: 'Disponible', viajeAsignado: false });
                promises.push(promise);
            }

            if (conductor) {
                const promise = firebase.database().ref('Empleados').child(conductor).update({ espera: true, viajeAsignado: false });
                promises.push(promise);
            }

            const promise = firebase.database().ref('ProgramacionDia').child(key).update({ estado: 'Cancelado', justificacion })
            promises.push(promise);

            this.liberarScanner(key);

            await Promise.all(promises);
            this.setState({ justificacion: '', showModal: false });
            sendLog({ tipo: 'viaje_cancelado', informacion_extra: { programacionDia: key } });
            Alert.success('Viaje cancelado con éxito', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
        } else {
            Alert.warning('Por favor, justifique la cancelación del viaje', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
        }
    }



    async liberarViaje() {

        const { ruta } = this.state;
        const { vehiculo, conductor } = ruta;

        const promises = [];
        if (vehiculo) {
            const promise = firebase.database().ref('Vehiculos').child(vehiculo).update({ estado: 'Disponible', viajeAsignado: false });
            promises.push(promise);
        }

        if (conductor) {
            const promise = firebase.database().ref('Empleados').child(conductor).update({ true: false, viajeAsignado: false })
            promises.push(promise);
        }

		await this.liberarScanner(ruta.key);
        const promise =  firebase.database()
		.ref('ProgramacionDia')
		.child(ruta.key)
		.update({ 
			estado: 'Pendiente', 
			conductor: '', 
			inicio: '', 
			finalizo: '', 
			vehiculo: '', 
			carretera: '', 
			kmFinal: '', 
			kmInicio: '', 
			puntoA: 0,
			codigo:false,
			comentario: `Viaje liberado ${moment().format('DD/MM/YYYY HH:mm')}`,
		});

        promises.push(promise);

		

        await Promise.all(promises);
        sendLog({ tipo: 'viaje_liberado', informacion_extra: { programacionDia: ruta.key } });
        Alert.success('Viaje liberado con éxito', { effect: 'genie', position: 'bottom-right', timeout: 3000 });

    }


    handleChangeDatePicker = () => { //corregir
        const fecha = this.fecha1.value;
        const splitfecha = fecha.split("-");
        if (splitfecha[0] < 2019) return;

        const formatdate = new Date(splitfecha[0] + '/' + splitfecha[1] + '/' + splitfecha[2]);
        this.props.cambiarFecha(formatdate)
    }

    getProgramacionDiaFecha = (empresa, fecha1) => {
        let findProgra = []
        let { programacion } = this.state

        firebase.database().ref('ProgramacionDia').orderByChild('fecha').equalTo(String(fecha1)).once('value').then(snap => {
            let programacionDia = [];
            snap.forEach(element => {
                let datos = element.val();
                let obje = {};
                findProgra = programacion.find(pfind => {
                    return pfind.key === datos.programacion;
                })
                if (empresa.value === 0) {
                    let splitH = datos.horaInicio.split(":");
                    let now = moment().hour(Number(splitH[0])).minute(Number(splitH[1])).format('HH:mm');
                    let fecha = new Date(datos.fecha);
                    let hoy = new Date(fecha1);
                    if ((new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()).getTime() === new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()).getTime())) {
                        obje = { ...datos, key: element.key, horaInicio: now, solicitante: findProgra.solicitante };
                        obje['estadoViaje'] = datos.estado
                        programacionDia.push(obje);
                    }
                } else {
                    if (findProgra.solicitante === empresa.value) {
                        let splitH = datos.horaInicio.split(":");
                        let now = moment().hour(Number(splitH[0])).minute(Number(splitH[1])).format('HH:mm');
                        let fecha = new Date(datos.fecha);
                        let hoy = new Date(fecha1);
                        if ((new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()).getTime() === new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()).getTime())) {
                            obje = { ...datos, key: element.key, horaInicio: now, solicitante: findProgra.solicitante };
                            obje['estadoViaje'] = datos.estado
                            programacionDia.push(obje);
                        }
                    }
                }
            });
            this.mergeRutas(programacionDia, programacion, true);
        })
    }

    printTable(data) {
        return data.map((ruta, index) => {
            return (
                <tr className='displayD' id={index} key={'reserva' + index} >
                    <td style={{ width: 133 }}>{ruta.programacionF.vuelo}</td>
                    <td style={{ width: 108 }}>{ruta.rutaF.nombRuta}</td>
                    <td style={{ width: 39 }}>{ruta.horaInicio}</td>
                    <td style={{ width: 39 }}>{ruta.horaLlegada}</td>
                    <td style={{ width: 97 }}>{this.getFirstWord(ruta.rutaF.inicio === undefined ? '--' : ruta.rutaF.inicio.nombre, ',')}</td>
                    <td style={{ width: 105 }}>{this.getFirstWord(ruta.rutaF.destino === undefined ? '--' : ruta.rutaF.destino.nombre, ',')}</td>
                    <td style={{ width: 70 }}>{this.getConductor(ruta.conductor, true)}</td>
                    <td style={{ width: 61 }}>{this.getVehiculo(ruta.vehiculo, true)}</td>
                    <td style={{ width: 123 }}><button onClick={() => this.liberar(ruta)} className="btn btn-small btn-warning">Liberar Viaje</button></td>
                    <td style={{ width: 136 }}><button onClick={() => this.showModal(ruta)} className="btn btn-small btn-danger">Cancelar Viaje</button></td>
                    <td style={{ width: 133 }}><button onClick={() => this.showModalFinalizar(ruta)} className="btn btn-small btn-warning">Finalizar Viaje</button></td>
                </tr>
            )
        })
    }

    render() {
        console.log(this.state.filtro)
        const { filtro } = this.state;
        const { isLoading } = this.props

        const filterRutas = this.props.filteredRutas.filter(obje => '' + obje.estadoViaje !== 'Cancelado' && obje.estadoViaje !== 'Finalizado')
        .filter((dato => this.state.filtro.value === 'Todos' ? true : ('' + dato.rutaF.tipoViaje === this.state.filtro.value)))

        if (isLoading) {
            return <Pulse />
        } else {
            let maxDate = moment(new Date()).format('YYYY-MM-DD')
            return (
                <div>
                    {this.state.template ? <Alert timeout='none' stack={{ limit: 1 }} contentTemplate={this.AlertaContenido} /> : <Alert stack={{ limit: 1 }} html={true} />}
                    <div className="row">
                        <div className="col-12 col-md-8">
                            <form>
                                <div className="row">
                                    <div className="col-sm-4 col-xs-4">
                                        <div className="form-group">
                                            <label className="col-form-label">Rutas</label>
                                            <Select placeholder='Seleccione...' value={filtro} className="css-10nd86i-2" onChange={(e) => this.selectTipoViaje(e)} options={this.props.tiposViajes} />
                                        </div>
                                    </div>
                                    <div className="col-sm-4 col-xs-4">
                                        <div className="form-group">
                                            <label className="col-form-label">Fecha</label>
                                            <input type="date" name="fecha1" max={maxDate} className="form-control" onChange={this.handleChangeDatePicker.bind(this)}
                                                ref={input => { this.fecha1 = input }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="container row justify-content-md-center">
                        <div className="col-12" style={{ marginTop: '2%' }}>
                            <div style={{ minHeight: '300px' }} className="table-responsive text-center">
                                <h4>{this.props.fecha && 'Fecha: ' + this.props.fecha}</h4>
                                <table className="paleBlueRows centerItem">
                                    <thead style={{ display: 'block' }}>
                                        <tr>
                                            <th style={{ width: 133 }}>Programacion</th>
                                            <th style={{ width: 108 }}>Rutas</th>
                                            <th style={{ width: 39 }}>Hr. Part</th>
                                            <th style={{ width: 39 }}>Hr. Lleg</th>
                                            <th style={{ width: 97 }}>Origen</th>
                                            <th style={{ width: 105 }}>Destino</th>
                                            <th style={{ width: 70 }}>Conductor Asignado</th>
                                            <th style={{ width: 61 }}>Vehículo Asignado</th>
                                            <th style={{ width: 123 }}></th>
                                            <th style={{ width: 136 }}></th>
                                            <th style={{ width: 133 }}></th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ height: '80vh', overflow: 'auto', display: 'block' }}>
                                        {
                                            this.printTable(filterRutas)
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <Modal key='modal' isOpen={this.state.showModal} onRequestClose={() => this.setState({ showModal: false })} style={customStyles}>
                        <div style={{ marginTop: 10 }} className="row">
                            <div className="col-12" >
                                <h3 className="title-blue" style={{ marginBottom: '2%' }}>Cancelar viaje</h3>
                                <div className="row">
                                    <div className="col-12 col-md-12">
                                        <textarea style={{ minHeight: '75%' }} placeholder='Motivo de la cancelación' onBlur={this.handleChange} className="form-control form-control-bg"></textarea>
                                    </div>
                                    <div className="col-12 col-md-12">
                                        <button onClick={() => this.cancelarViaje()} className="btn btn-red float-right">Continuar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal key='modalFinalizar' isOpen={this.state.showModalFinalizar} onRequestClose={() => this.setState({ showModalFinalizar: false })} style={customStylesModalFinalizar}>
                        <div style={{ marginTop: 10 }} className="row">
                            <div className="col-12" >
                                <h3 className="title-blue" style={{ marginBottom: '2%' }}>Finalizar viaje</h3>
                                <div className="row">
                                    <div className="col-12 col-md-12">
										<textarea style={{ minHeight: '75%' }} placeholder='Comentarios' required className="form-control form-control-bg" name="comentario" onBlur={this.handleModalFinalizar.bind(this)}></textarea>
                                    </div>
                                    <div className="col-12 col-md-12">
                                        <select className="form-control" onChange={this.handleModalFinalizar.bind(this)} name="carretera">
                                            <option selected value=''>Seleccione carretera</option>

                                            {this.state.carreteras.map((value, i) => (
                                                <option value={value.valor} key={i}>{value.valor}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-12 col-md-12 form-group">
                                        <label htmlFor="km" >Kilometraje</label>
                                        <input className="form-control" id="km" type="number" min="0" name="km" onBlur={this.handleModalFinalizar.bind(this)} />
                                    </div>
                                    <div className="col-12 col-md-12">
                                        <button className="btn btn-red float-right" onClick={this.finalizarViaje.bind(this)}>Continuar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            )
        }

    }
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '500px',
        height: '200px',
    }
}
const customStylesModalFinalizar = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '500px',
        height: '350px',
    }
}


const mapStateToProps = (state) => ({
    programacionDia: state.programacionDia
})
export default connect(mapStateToProps, { setProgramacion })(withRouter(CancelacionViaje));


// WEBPACK FOOTER //
// ./src/Components/Rutas/CancelacionViaje.js